import React, { useState, useEffect } from "react";
import { api } from "../../hooks/api";
import { ContentWrapper, ExpandableContent } from "../../styled/TableStyles";
import Spinner from "../../../shared/components/LoadingPage";
import CustomTable from "../CustomTable";
import { ColumnAttribute } from "../../../configs/productOrder";
import { DEFAULT_PAGE_SIZE } from "../../../configs/apiConfig";
import { SubTitleText } from "../../styled/TitleBar";

interface ListViewProps {
    url: string;
    defaultPageSize?: number;
    processItem?: Function;
    rowElement: any;
    tableColumns: ColumnAttribute[];
    subTitleText?: string;
}

const ListViewTable = ({
    url,
    defaultPageSize,
    processItem,
    rowElement,
    tableColumns,
    subTitleText,
}: ListViewProps) => {
    const [{ data, variables, isLoading, setLocalUrl }, fetchItems] = api.get(
        url,
        {
            page_size: defaultPageSize || DEFAULT_PAGE_SIZE,
        },
        false
    );

    useEffect(() => {
        setLocalUrl(url);
        fetchItems();
    }, [url]);

    const rawItems = data?.results || [];
    const processedItems = processItem ? rawItems.map(processItem) : rawItems;

    return (
        <ContentWrapper>
            <SubTitleText> {subTitleText} </SubTitleText>
            <ExpandableContent>
                {isLoading ? (
                    <Spinner />
                ) : (
                    <CustomTable
                        itemList={processedItems}
                        RowElement={rowElement}
                        TableColumns={tableColumns}
                    />
                )}
            </ExpandableContent>
        </ContentWrapper>
    );
};

export default ListViewTable;
